import { gql } from "graphql-request";

export const commentThreadsData = {
  getCommentThreads: gql`
    query CommentThreadsData($assetId: String!, $group: CommentThreadsGroup!) {
      commentThreadsData(assetId: $assetId, group: $group) {
        commentThreads {
          threadId
          assetId
          visibility
          comments {
            id
            authorId
            author {
              firstName
              lastName
            }
            authorRoles {
              roleId
            }
            authorOrganization {
              name
              shortName
              country
            }
            content
            createdDate
            lastModifiedDate
          }
          highlightAreas {
            pageIndex
            top
            left
            width
            height
          }
          isResolved
          resolvedBy
          resolvedDate
        }
        totalUnresolved
      }
    }
  `,
};
